export const Constants = {
    APP_NAME: " Componenta App",
    APP_LABEL: "КОМПОНЕНТА",
    SERVER_URL: "http://localhost:9000",
    POST_SERVER_URL: "https://e-learning.acinus.org",
    AUTH_PREFIX: "/login.php",
    SIGNUP_PREFIX: "/register.php",
    UPDATE_PROFILE_PREFIX: "/update-profile.php",
    GOOGLE_AUTH_PREFIX: "/google-auth.php",
    GET_ITEMS_PREFIX: "/get-items.php",
    SEND_ORDER_PREFIX: "/send-order.php",
    CREATE_ORDER_PREFIX: "/create-order.php",
    GET_ITEM_PREFIX: "/get-item.php",
    SAVE_ITEM_PREFIX: "/save-item.php",
    GET_USERS_PREFIX: "/get-users.php",
    UPDATE_USER_PREFIX: "/update-user.php",
    SEND_VERIFICATION_PREFIX: "/send-verification.php",
    VERIFY_REGISTER_PREFIX: "/verify-register.php",
    GET_ORDERS_PREFIX: "/get-orders.php",
    GET_ORDER_DETAILS_PREFIX: "/get-order-details.php",
    UPDATE_ORDER_PREFIX: "/update-order.php",
    CONFIRM_ORDER_PREFIX: "/confirm-order.php",
    GET_CATEGORIES_PREFIX: "/get-categories.php",
    SAVE_CATEGORY_PREFIX: "/save-category.php",
    NOT_FOUND_IMAGE: "unknown.jpg",
};
